module.exports = __webpack_public_path__ + "static/img/暂无关注.0c31770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无关注.jpg
// module id = 17JF
// module chunks = 1